import { Directive, ElementRef, EventEmitter, inject, input, InputSignal, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent, throttleTime } from 'rxjs';

@Directive({
  selector: '[appThrottleClick]',
  standalone: true
})
export class ThrottleClickDirective {
  private readonly _element: ElementRef<HTMLElement> = inject<ElementRef<HTMLElement>>(ElementRef);

  public leading: InputSignal<boolean> = input(true);

  public trailing: InputSignal<boolean> = input(true);

  public throttleTimeMs: InputSignal<number> = input(800);

  @Output() public readonly appThrottleClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();


  constructor () {
    fromEvent<MouseEvent>(this._element.nativeElement, "click")
      .pipe(
        throttleTime(this.throttleTimeMs(), undefined, {
          leading: this.leading(),
          trailing: this.trailing()
        }),
        takeUntilDestroyed()
      )
      .subscribe((mouseEvent: MouseEvent) => {
        this.appThrottleClick.emit(mouseEvent);
      });
  }
}
